import PropTypes from "prop-types";

export const GeneTranscriptType = PropTypes.arrayOf(
  PropTypes.shape({
    canonical: PropTypes.bool,
    chromo: PropTypes.string,
    coding_length: PropTypes.number,
    cytoband: PropTypes.string,
    ensembl_support_level: PropTypes.string,
    length: PropTypes.number,
    mrna_length: PropTypes.number,
    name: PropTypes.string,
    position: PropTypes.number,
    strand: PropTypes.string,
  })
);
